import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import { Helmet } from "react-helmet";
import './BlogPost.css';

interface Author {
  id: number;
  name: string;
}
interface BlogPost {
  id: number;
  title: string;
  text: string;
  image: string;
  created_at: string;
  updated_at: string;
  author: Author;
  slug?: string;
}

const BlogPost: React.FC = () => {
  const { postId } = useParams();
  const navigate = useNavigate();
  const [post, setPost] = useState<BlogPost | null>(null);
  const [loading, setLoading] = useState(true);
  const [latestPosts, setLatestPosts] = useState<BlogPost[]>([]);

  useEffect(() => {
    axios.get(`https://api.tellida.com/api/blogs/${postId}`)
      .then(res => setPost(res.data))
      .finally(() => setLoading(false));
  }, [postId]);

  useEffect(() => {
    axios.get('https://api.tellida.com/api/blogs')
      .then(res => setLatestPosts(res.data))
      .catch(() => setLatestPosts([]));
  }, []);

  if (loading) return <div className="loading">Loading...</div>;
  if (!post) return <div className="error">Post not found</div>;

const description = post.text.replace(/<[^>]+>/g, '').slice(0, 160) + "...";


  return (
  <>
    <Helmet>
      <title>{post.title} | Tellida Magazine</title>
      <meta name="description" content={description} />
    </Helmet>

    {/* Luxury Hero Section */}
    <section
      className="luxury-hero"
      style={{ backgroundImage: `url(${post.image})` }}
    >
      <div className="luxury-hero-overlay" />
      <div className="luxury-hero-content">
        <h1 className="luxury-title">{post.title}</h1>
        <p className="luxury-meta">
          By {post.author.name} — {new Date(post.created_at).toLocaleDateString()}
        </p>
      </div>
    </section>

    {/* MAIN CONTENT + SIDEBAR WRAPPER */}
    <div className="luxury-layout">

      {/* MAIN ARTICLE CONTENT */}
      <div className="luxury-article-container">
        <div
          className="luxury-content"
          dangerouslySetInnerHTML={{ __html: post.text }}
        ></div>

        <button className="luxury-back" onClick={() => navigate(-1)}>
          ⟵ Back to Articles
        </button>
      </div>

      {/* RIGHT SIDE SIDEBAR */}
      <aside className="luxury-sidebar">
        <h3 className="sidebar-title">Latest Articles</h3>

        {latestPosts.slice(0, 5).map((item) => (
          <div
            key={item.id}
            className="sidebar-article"
            onClick={() => navigate(`/blog/${item.slug || item.id}`)}
          >
            <img src={item.image} alt={item.title} />
            <div>
              <h4>{item.title}</h4>
              <p>{new Date(item.created_at).toLocaleDateString()}</p>
            </div>
          </div>
        ))}
      </aside>

    </div>
  </>
);

};

export default BlogPost;
